
import { store } from './gloveSelectorStore';
import { STORE_ACTION_TYPES } from "../helper/constants";
import { fetchAPI, METHODS } from "../helper/functions/axios";
//Actions
export const setAppKey = () => {
    fetchAPI(METHODS.POST, "/api/config/setAppKey").then((response) => {
        const respIsSucess = response?.data?.message?.isSuccess;
        if (respIsSucess) {
            store.dispatch({ type: STORE_ACTION_TYPES.SET_KEY_STATUS, payload: { sucess: respIsSucess } });
        }
    });
};
export const setConfig = (resources) => {
    store.dispatch({ type: STORE_ACTION_TYPES.INIT, payload: resources });
};

export const setCalculator = (resources) => {
    store.dispatch({ type: STORE_ACTION_TYPES.CALCULATOR, payload: resources });
};
export const setLanguageHF = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.LANGUAGE_CHANGE_IND_HF, payload: keys });
};
export const setAppLanguageSelector = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.APP_LANGUAGE_CHANGE, payload: keys });
};

export const setFilterFacets = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.SET_FILTER_FACETS, payload: keys });
}
export const setSelectedChemicalsInStore = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.USER_SELECTED_CHEMICALS, payload: keys });
};
export const setSelectedChemicalsArrayInStore = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.USER_SELECTED_CHEMICALS_ARRAY, payload: keys });
};
export const setStyleNumbersInStore = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.PRODUCT_STYLE_NUMBERS_ARRAY, payload: keys });
}
export const setGloveResultsInStore = (keys) => {
    store.dispatch({ type: STORE_ACTION_TYPES.GLOVE_RESULTS, payload: keys });
};
// export const setChemicalSearchResponse = (keys) => {
//     store.dispatch( { type: STORE_ACTION_TYPES.CHEMICAL_SEARCH_RESPONSE, payload: keys });    
// };
export const setResetCalculator = (resources) => {
    store.dispatch({ type: STORE_ACTION_TYPES.RESET_CALCULATOR, payload: resources });
};